var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothesHanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 6C9.00006 4.34315 10.3432 3 12.0001 3C13.6569 3 15.0001 4.34315 15.0001 6V6.17157C15.0001 6.96722 14.684 7.73028 14.1214 8.29289L13.293 9.12132C13.1054 9.30886 13.0001 9.56321 13.0001 9.82843V9.93076L22.2458 15.4204C24.8683 16.9776 23.7642 21 20.7142 21H3.28591C0.235961 21 -0.868211 16.9775 1.7543 15.4204L11.0001 9.93076V9.82843C11.0001 9.03278 11.3161 8.26972 11.8787 7.70711L12.7072 6.87868C12.8947 6.69114 13.0001 6.43679 13.0001 6.17157V6C13.0001 5.44772 12.5523 5 12.0001 5C11.4478 5 11.0001 5.44772 11.0001 6C11.0001 6.55228 10.5523 7 10.0001 7C9.44778 7 9.00006 6.55228 9.00006 6ZM12.0001 11.663L2.77538 17.1401C1.9012 17.6592 2.26927 19 3.28591 19H20.7142C21.7309 19 22.0989 17.6592 21.2248 17.1401L12.0001 11.663Z",
    fill: "#000000",
    id: "id_101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothesHanger);
export default __webpack_public_path__ + "static/media/clothes-hanger.8a722173b8b2d0c517e6f7f0d90d4ef5.svg";
export { ForwardRef as ReactComponent };